module.exports = __webpack_public_path__ + "img/icons.6d1fb493.svg";